/**
 * Create default mutations for a given type
 */
export default function createAsyncMutation(type) {
  return {
    SUCCESS: `${type}_SUCCESS`,
    FAILURE: `${type}_FAILURE`,
    PENDING: `${type}_PENDING`
  }
}



// WEBPACK FOOTER //
// ./src/utils/generators.js